import React from "react";
import PropTypes from "prop-types";
import { FilterSelect, inlineSelectComponents } from "@td/ui";
import { translate } from "@td/shared_utils";
import { statusCodes } from "../constants";

const { CheckboxOption } = inlineSelectComponents;

const options = [
  {
    value: statusCodes.NOT_STARTED,
    label: translate(null, "care_team_tasks.statuses", "NOTSTARTED"),
  },
  {
    value: statusCodes.IN_PROGRESS,
    label: translate(null, "care_team_tasks.statuses", "INPROGRESS"),
  },
  {
    value: statusCodes.COMPLETED,
    label: translate(null, "care_team_tasks.statuses", "COMPLETED"),
  },
  {
    value: statusCodes.CANCELLED,
    label: translate(null, "care_team_tasks.statuses", "CANCELLED"),
  },
];

const filterDropdownProps = {
  style: {
    minWidth: 140,
  },
  "data-testid": "status-filter",
};

const StatusFilter = React.memo((props) => (
  <FilterSelect
    {...props}
    isMulti
    isSearchable={false}
    options={options}
    label={translate(null, "care_team_tasks.filters.fields.status", "label")}
    filterDropdownProps={filterDropdownProps}
    components={{
      Option: CheckboxOption,
      Control: () => null,
    }}
  />
));

StatusFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

StatusFilter.displayName = "StatusFilter";

export default StatusFilter;
